import { useEffect, useRef } from 'react';

// unused — paid API needed for tile customization
// eslint-disable-next-line no-unused-vars
const MAP_STYLE = [
  { featureType: 'water',            stylers: [{ color: '#a8d5aa' }] },
  { featureType: 'landscape',        stylers: [{ color: '#efefef' }] },
  { featureType: 'landscape.natural.terrain', stylers: [{ color: '#e0e8e0' }] },
  { featureType: 'road',             elementType: 'geometry',        stylers: [{ color: '#ffffff' }] },
  { featureType: 'road',             elementType: 'geometry.stroke', stylers: [{ color: '#cccccc' }] },
  { featureType: 'road.highway',     elementType: 'geometry',        stylers: [{ color: '#e4e4e4' }] },
  { featureType: 'poi',              elementType: 'geometry',        stylers: [{ color: '#e4e4e4' }] },
  { featureType: 'poi.park',         elementType: 'geometry',        stylers: [{ color: '#d4e8d4' }] },
  { featureType: 'transit',          elementType: 'geometry',        stylers: [{ color: '#e0e0e0' }] },
  { featureType: 'administrative',   elementType: 'geometry.stroke', stylers: [{ color: '#bbbbbb' }] },
  { featureType: 'all',              elementType: 'labels.text.fill',   stylers: [{ color: '#444444' }] },
  { featureType: 'all',              elementType: 'labels.text.stroke', stylers: [{ color: '#f0f0f0' }] },
];

const YandexMap = ({ points = [], showRoute = true, height = 400 }) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!points.length || !containerRef.current) return;

    const apiKey = process.env.REACT_APP_YANDEX_MAPS_KEY || '';
    const scriptId = 'ymaps-script';

    const init = () => {
      window.ymaps.ready(() => {
        if (mapRef.current) mapRef.current.destroy();

        const visible = points.filter(p => !p.hidden);
        const forCenter = visible.length ? visible : points;
        const center = [
          forCenter.reduce((s, p) => s + p.lat, 0) / forCenter.length,
          forCenter.reduce((s, p) => s + p.lng, 0) / forCenter.length,
        ];

        const map = new window.ymaps.Map(containerRef.current, {
          center,
          zoom: forCenter.length === 1 ? 12 : 9,
          controls: ['zoomControl', 'fullscreenControl'],
        });

        // Grayscale only on tile layer, markers/route stay in color
        const applyGrayscale = () => {
          try {
            const groundEl = map.panes.get('ground').getElement();
            if (groundEl) groundEl.style.filter = 'grayscale(1)';
          } catch (_) {}
        };
        applyGrayscale();
        setTimeout(applyGrayscale, 500);

        mapRef.current = map;

        let visibleNum = 0;
        points.forEach((p) => {
          if (p.hidden) return;
          visibleNum++;
          const mark = new window.ymaps.Placemark(
            [p.lat, p.lng],
            {
              balloonContent: p.title || `Точка ${visibleNum}`,
              iconContent: visibleNum,
            },
            { preset: 'islands#darkOrangeStretchyIcon' }
          );
          map.geoObjects.add(mark);
        });

        if (showRoute && points.length > 1) {
          const coords = points.map(p => [p.lat, p.lng]);
          const polyline = new window.ymaps.Polyline(
            coords,
            {},
            { strokeColor: '#db782e', strokeWidth: 3, strokeOpacity: 0.9 }
          );
          map.geoObjects.add(polyline);
          map.setBounds(map.geoObjects.getBounds(), { checkZoomRange: true, zoomMargin: 40 });
        }
      });
    };

    if (window.ymaps) {
      init();
    } else if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://api-maps.yandex.ru/2.1/?apikey=${apiKey}&lang=ru_RU`;
      script.onload = init;
      document.head.appendChild(script);
    } else {
      document.getElementById(scriptId).addEventListener('load', init);
    }

    return () => {
      if (mapRef.current) { mapRef.current.destroy(); mapRef.current = null; }
    };
  }, [points, showRoute]);

  if (!points.length) return null;

  return (
    <div
      ref={containerRef}
      style={{ width: '100%', height, borderRadius: 12, overflow: 'hidden' }}
    />
  );
};

export default YandexMap;
